import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { OPEN_UPGRADE_MODAL_EVENT, redirectToStripePackageCheckout } from "../../shared/billing";
import ChatIcon from "./icons/chat.svg";
import CandidateIcon from "./icons/candidate.svg";
import SearchIcon from "./icons/search.svg";

const FeatureGate = ({ featureName: propFeatureName, title, subtitle, iconType = 'chat', description, bottomText }) => {
  const { search } = useLocation();
  const planCode = useSelector((state) => state.plansReducer?.creditsBalance?.data?.planCode);
  const isStarterPlan = planCode === 'STARTER_MONTHLY' || planCode === 'STARTER_YEARLY';
  const params = new URLSearchParams(search);
  const featureName = propFeatureName || params.get("feature") || "This";
  const pageTitle = title || params.get("title") || "";
  const pageSubtitle = subtitle || params.get("subtitle") || "";

  return (
    <div style={{ backgroundColor: "#fff", minHeight: "calc(100vh - 64px)" }}>
      {pageTitle && (
        <div style={{ padding: "24px 32px 0" }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#1B1F25", margin: 0 }}>
            {pageTitle}
          </h2>
          {pageSubtitle && (
            <p style={{ fontSize: 13, color: "#667085", margin: "4px 0 0" }}>
              {pageSubtitle}
            </p>
          )}
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: pageTitle ? "calc(100vh - 160px)" : "calc(100vh - 64px)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            maxWidth: 440,
            padding: "0 24px",
          }}
        >
          {/* Icon with badge */}
          <div style={{ position: "relative", marginBottom: 24, display: "inline-block" }}>
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: 20,
                backgroundColor: "#eef4ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {iconType === 'search' ? (
                <img src={SearchIcon} alt="search" width="42" height="41" />
              ) : iconType === 'candidate' ? (
                <img src={CandidateIcon} alt="candidate" width="39" height="37" />
              ) : (
                <img src={ChatIcon} alt="chat" width="41" height="39" />
              )}
            </div>
            <span style={{ position: "absolute", top: -10, right: -10 }}>
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="36" height="36" rx="18" fill="#F48A2E"/>
                <path d="M13.7029 24.7582C13.3907 24.7582 13.1233 24.6471 12.9009 24.4247C12.6785 24.2023 12.5674 23.935 12.5674 23.6227V16.4611C12.5674 16.1477 12.6785 15.8795 12.9009 15.6564C13.1233 15.4332 13.3907 15.3216 13.7029 15.3216H14.7899V13.8094C14.7899 12.9164 15.1025 12.1561 15.7277 11.5284C16.3528 10.9007 17.1107 10.5869 18.0012 10.5869C18.8918 10.5869 19.6493 10.9007 20.2739 11.5284C20.8985 12.1561 21.2109 12.9164 21.2109 13.8094V15.3216H22.2979C22.6112 15.3216 22.8794 15.4332 23.1025 15.6564C23.3258 15.8795 23.4374 16.1477 23.4374 16.4611V23.6227C23.4374 23.935 23.3258 24.2023 23.1025 24.4247C22.8794 24.6471 22.6112 24.7582 22.2979 24.7582H13.7029ZM13.7029 23.6227H22.2979V16.4611H13.7029V23.6227ZM18.0032 21.3252C18.3569 21.3252 18.6587 21.2029 18.9087 20.9581C19.1587 20.7133 19.2837 20.419 19.2837 20.0752C19.2837 19.7419 19.1578 19.4391 18.9059 19.1669C18.654 18.8947 18.3512 18.7586 17.9975 18.7586C17.6439 18.7586 17.342 18.8947 17.092 19.1669C16.842 19.4391 16.717 19.7447 16.717 20.0836C16.717 20.4225 16.843 20.7141 17.0949 20.9586C17.3468 21.203 17.6495 21.3252 18.0032 21.3252ZM15.9254 15.3216H20.0754V13.8102C20.0754 13.2281 19.8745 12.7353 19.4729 12.3317C19.0712 11.9282 18.5813 11.7264 18.0032 11.7264C17.4252 11.7264 16.9344 11.9282 16.5309 12.3317C16.1272 12.7353 15.9254 13.2281 15.9254 13.8102V15.3216Z" fill="white"/>
              </svg>
            </span>
          </div>

          {/* Title */}
          <p
            style={{
              fontSize: 14,
              fontWeight: 500,
              color: "#1B1F25",
              marginBottom: 20,
              lineHeight: 1.6,
              maxWidth: 360,
            }}
          >
            {description || "Your free trial has ended. Choose a plan to continue using this feature."}
          </p>

          {/* Buttons */}
          <div style={{ display: "flex", gap: 10, marginBottom: 16 }}>
            <button
              onClick={() => isStarterPlan
                ? redirectToStripePackageCheckout({ productCode: planCode })
                : window.dispatchEvent(new CustomEvent(OPEN_UPGRADE_MODAL_EVENT, { detail: { modalType: 'manageSubscription' } }))
              }
              style={{
                backgroundColor: "#011D28",
                color: "#fff",
                border: "none",
                borderRadius: 5,
                padding: "9px 24px",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              {isStarterPlan ? "Renew Plan" : "Choose Plan"}
            </button>
            <button
              onClick={() => window.dispatchEvent(new CustomEvent(OPEN_UPGRADE_MODAL_EVENT, { detail: { modalType: 'manageSubscription' } }))}
              style={{
                backgroundColor: "#fff",
                color: "#011D28",
                border: "1.5px solid #c0cdd4",
                borderRadius: 5,
                padding: "9px 24px",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              {isStarterPlan ? "Upgrade Plan" : "See Pricing"}
            </button>
          </div>

          {/* Footer text */}
          <p style={{ fontSize: 12, color: "#98a2b3", margin: 0, lineHeight: 1.6, textAlign: "center" }}>
            {bottomText || `${featureName} is a paid feature and was given to you for free during your trial period.`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default FeatureGate;
